module.exports = __webpack_public_path__ + "img/7D6651_F8E3BF_CEA987_E7C29C-256px.76271e91.png";